/**
 * Maps Unicode "fancy" characters (e.g. Mathematical Monospace, Bold, Italic,
 * Script, Fraktur, Sans-Serif variants) back to their plain Latin equivalents
 * using NFKC decomposition. Prevents polluting data and breaking downstream systems.
 */
export const normaliseUnicodeText = (text: string): string => text.normalize('NFKC');
